export default {
  data() {
    return {
      mailTechnicalKeyConst: [
        {label: this.$t('mail_template.technical_key.AccessAutonomousOwner'), value: 'AccessAutonomousOwner'},
        {
          label: this.$t('mail_template.technical_key.AccessAutonomousOwner_commerciale'),
          value: 'AccessAutonomousOwner_commerciale',
        },
        {
          label: this.$t('mail_template.technical_key.AccessAutonomousOwnerEstimation'),
          value: 'AccessAutonomousOwnerEstimation',
        },
        {
          label: this.$t('mail_template.technical_key.AccessAutonomousOwnerEstimation_commerciale'),
          value: 'AccessAutonomousOwnerEstimation_commerciale',
        },
        {
          label: this.$t('mail_template.technical_key.AccessPasswordForgotEmployee'),
          value: 'AccessPasswordForgotEmployee',
        },
        {
          label: this.$t('mail_template.technical_key.AccessPasswordForgotOwner'),
          value: 'AccessPasswordForgotOwner',
        },
        {
          label: this.$t('mail_template.technical_key.PasswordUpdateConfirm'),
          value: 'PasswordUpdateConfirm',
        },
        {label: this.$t('mail_template.technical_key.CRGFirst'), value: 'CRGFirst'},
        {label: this.$t('mail_template.technical_key.CRGHost'), value: 'CRGHost'},
        {label: this.$t('mail_template.technical_key.CRGMulti'), value: 'CRGMulti'},
        {
          label: this.$t('mail_template.technical_key.MandatAvenantSigned_hote'),
          value: 'MandatAvenantSigned_hote',
        },
        {
          label: this.$t('mail_template.technical_key.MandatAvenantSigned_owner'),
          value: 'MandatAvenantSigned_owner',
        },
        {label: this.$t('mail_template.technical_key.MandatAvenantToSign'), value: 'MandatAvenantToSign'},
        {
          label: this.$t('mail_template.technical_key.MandatResiliationCheckList'),
          value: 'MandatResiliationCheckList',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationCheckList_comptabilite'),
          value: 'MandatResiliationCheckList_comptabilite',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDeclared_concierge'),
          value: 'MandatResiliationDeclared_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDeclared_distribution'),
          value: 'MandatResiliationDeclared_distribution',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDeclared_hote'),
          value: 'MandatResiliationDeclared_hote',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDeclared_owner'),
          value: 'MandatResiliationDeclared_owner',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDone_distribution'),
          value: 'MandatResiliationDone_distribution',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDone_hote'),
          value: 'MandatResiliationDone_hote',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDone_owner'),
          value: 'MandatResiliationDone_owner',
        },
        {label: this.$t('mail_template.technical_key.OnboardingCreated_hote'), value: 'OnboardingCreated_hote'},
        {
          label: this.$t('mail_template.technical_key.OnboardingStep1Validated'),
          value: 'OnboardingStep1Validated',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_concierge'),
          value: 'OnboardingStep2Updated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_confort'),
          value: 'OnboardingStep2Updated_confort',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_essentielle'),
          value: 'OnboardingStep2Updated_essentielle',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_hote'),
          value: 'OnboardingStep2Updated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_premium'),
          value: 'OnboardingStep2Updated_premium',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_distribution'),
          value: 'OnboardingStep2Updated_distribution',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_commerciale'),
          value: 'OnboardingStep2Validated_commerciale',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_concierge'),
          value: 'OnboardingStep2Validated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_confort'),
          value: 'OnboardingStep2Validated_confort',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_essentielle'),
          value: 'OnboardingStep2Validated_essentielle',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_hote'),
          value: 'OnboardingStep2Validated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_premium'),
          value: 'OnboardingStep2Validated_premium',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_distribution'),
          value: 'OnboardingStep2Validated_distribution',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep3Validated'),
          value: 'OnboardingStep3Validated',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep3Validated_hote'),
          value: 'OnboardingStep3Validated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep4Validated'),
          value: 'OnboardingStep4Validated',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep4Validated_concierge'),
          value: 'OnboardingStep4Validated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep4Validated_hote'),
          value: 'OnboardingStep4Validated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5DocsRefused'),
          value: 'OnboardingStep5DocsRefused',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5DocsValidated'),
          value: 'OnboardingStep5DocsValidated',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5DocsResubmitted'),
          value: 'OnboardingStep5DocsResubmitted',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated'),
          value: 'OnboardingStep5Validated',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated_commerciale'),
          value: 'OnboardingStep5Validated_commerciale',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated_comptabilite'),
          value: 'OnboardingStep5Validated_comptabilite',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated_confort_premium_hote'),
          value: 'OnboardingStep5Validated_confort_premium_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated_essentielle_hote'),
          value: 'OnboardingStep5Validated_essentielle_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated_conciergerie'),
          value: 'OnboardingStep5Validated_conciergerie',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_communication'),
          value: 'OnboardingStep6Published_communication',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_hote'),
          value: 'OnboardingStep6Published_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_owner'),
          value: 'OnboardingStep6Published_owner',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_voyageur'),
          value: 'OnboardingStep6Published_voyageur',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_distribution'),
          value: 'OnboardingStep6Published_distribution',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCanceled_concierge'),
          value: 'ReservationGuestCanceled_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCanceled_hote'),
          value: 'ReservationGuestCanceled_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCanceled_owner'),
          value: 'ReservationGuestCanceled_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCreated_concierge'),
          value: 'ReservationGuestCreated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCreated_hote'),
          value: 'ReservationGuestCreated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCreated_owner'),
          value: 'ReservationGuestCreated_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestUpdated_concierge'),
          value: 'ReservationGuestUpdated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestUpdated_hote'),
          value: 'ReservationGuestUpdated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestUpdated_owner'),
          value: 'ReservationGuestUpdated_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCanceled_concierge'),
          value: 'ReservationHostCanceled_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCanceled_hote'),
          value: 'ReservationHostCanceled_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCanceled_owner'),
          value: 'ReservationHostCanceled_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCreated_concierge'),
          value: 'ReservationHostCreated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCreated_hote'),
          value: 'ReservationHostCreated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCreated_owner'),
          value: 'ReservationHostCreated_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostUpdated_concierge'),
          value: 'ReservationHostUpdated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostUpdated_hote'),
          value: 'ReservationHostUpdated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostUpdated_owner'),
          value: 'ReservationHostUpdated_owner',
        },
        {
          label: this.$t('mail_template.technical_key.StayRateMissing'),
          value: 'StayRateMissing',
        },

        {
          label: this.$t('mail_template.technical_key.AccessUser'),
          value: 'AccessUser',
        },

        {
          label: this.$t('mail_template.technical_key.MaintenanceCreated'),
          value: 'MaintenanceCreatedHote',
        },
        {
          label: this.$t('mail_template.technical_key.MaintenanceCreated_voyageur'),
          value: 'MaintenanceCreatedPole_voyageur',
        },
        {
          label: this.$t('mail_template.technical_key.MaintenanceCreated_hote'),
          value: 'MaintenanceCreatedPole_hote',
        },
        {
          label: this.$t('mail_template.technical_key.LitigeCreated'),
          value: 'LitigeCreatedHote',
        },
        {
          label: this.$t('mail_template.technical_key.LitigeCreated_voyageur'),
          value: 'LitigeCreatedPole_voyageur',
        },
        {
          label: this.$t('mail_template.technical_key.LitigeWon'),
          value: 'LitigeWon',
        },
        {
          label: this.$t('mail_template.technical_key.LitigeLost'),
          value: 'LitigeLost',
        },
        {
          label: this.$t('mail_template.technical_key.MaintenanceResolved'),
          value: 'MaintenanceResolved',
        },
        {
          label: this.$t('mail_template.technical_key.AccessReactivateOwner'),
          value: 'AccessReactivateOwner',
        },
        {
          label: this.$t('mail_template.technical_key.LoginCode'),
          value: 'LoginCode',
        },
        {
          label: this.$t('mail_template.technical_key.SmilySyncedProduct'),
          value: 'SmilySyncedProduct',
        },
        {
          label: this.$t('mail_template.technical_key.SmilySyncedDistribution'),
          value: 'SmilySyncedDistribution',
        },
        {
          label: this.$t('mail_template.technical_key.MandatOperatingCosts'),
          value: 'MandatOperatingCosts',
        },
        {
          label: this.$t('mail_template.technical_key.RequestOwnerConfirmReceipt'),
          value: 'RequestOwnerConfirmReceipt',
        },
        {
          label: this.$t('mail_template.technical_key.TrustpilotOwnerRating'),
          value: 'TrustpilotOwnerRating',
        },
        {
          label: this.$t('mail_template.technical_key.HousekeeperMiddleOfTheMonth'),
          value: 'HousekeeperMiddleOfTheMonth',
        },
        {
          label: this.$t('mail_template.technical_key.HousekeeperEndOfTheMonth'),
          value: 'HousekeeperEndOfTheMonth',
        },
        // Nurturing emails
        {
          label: this.$t('mail_template.technical_key.NurturingS1AE1WelcomeAccess'),
          value: 'NurturingS1AE1WelcomeAccess',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS1AE2CustomerCase'),
          value: 'NurturingS1AE2CustomerCase',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS1AE3EasyUse'),
          value: 'NurturingS1AE3EasyUse',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS1AE4FAQ'),
          value: 'NurturingS1AE4FAQ',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS1AE5FOMO'),
          value: 'NurturingS1AE5FOMO',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS1BE1PresqueFini'),
          value: 'NurturingS1BE1PresqueFini',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS1BE2FormuleAttend'),
          value: 'NurturingS1BE2FormuleAttend',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS1BE3AideProposee'),
          value: 'NurturingS1BE3AideProposee',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS2E1RecommendationPremium'),
          value: 'NurturingS2E1RecommendationPremium',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS2E1RecommendationEssentiel'),
          value: 'NurturingS2E1RecommendationEssentiel',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS2E1RecommendationConfort'),
          value: 'NurturingS2E1RecommendationConfort',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS2E2HesitationPremium'),
          value: 'NurturingS2E2HesitationPremium',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS2E2HesitationEssentiel'),
          value: 'NurturingS2E2HesitationEssentiel',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS2E2HesitationConfort'),
          value: 'NurturingS2E2HesitationConfort',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS2E3Questions'),
          value: 'NurturingS2E3Questions',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS3E1OneMoreStep'),
          value: 'NurturingS3E1OneMoreStep',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS3E2MandateExplanation'),
          value: 'NurturingS3E2MandateExplanation',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS3E3Projection'),
          value: 'NurturingS3E3Projection',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS3E4FinancialComparison'),
          value: 'NurturingS3E4FinancialComparison',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS2ME130Seconds'),
          value: 'NurturingS2ME130Seconds',
        },
        {
          label: this.$t('mail_template.technical_key.NurturingS2ME2MistakeToAvoid'),
          value: 'NurturingS2ME2MistakeToAvoid',
        },
        {
          label: this.$t('mail_template.technical_key.UserEmailUpdate'),
          value: 'UserEmailUpdate',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationQueryReminderStep1'),
          value: 'ReservationQueryReminderStep1',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationQueryReminderStep2'),
          value: 'ReservationQueryReminderStep2',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationQueryReminderStep3'),
          value: 'ReservationQueryReminderStep3',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationQueryReminderStep4'),
          value: 'ReservationQueryReminderStep4',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationQueryReminderStep5'),
          value: 'ReservationQueryReminderStep5',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationDoubleCheck'),
          value: 'ReservationDoubleCheck',
        },
      ],
    };
  },
  methods: {
    displayForMailTechnicalKeyConst(value, returnLabel = '') {
      let result = this.mailTechnicalKeyConst.find((el) => el.value === value);
      return result ? result.label : returnLabel;
    },
  },
  computed: {
    technicalKeyConstAlphabetical() {
      return this.mailTechnicalKeyConst.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
    },
  },
};
